import { Box, CircularProgress, Container, Divider, Typography, Button } from "@mui/material";
import { PageProps } from "../_types/page.props.interface";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AcademyService } from "../services/academy.service";
import { useParams } from "react-router-dom";
import { Academy } from "../_types/academy.type";
import { StyleHelper } from "../helpers/styler-helper";
import { Formatters } from "../helpers/formatters";

export default function AcademyViewPage(props: PageProps) {


    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const academyService = new AcademyService(dispatch)
    const [academy, setAcademy] = useState<Academy | null>(null)
    const { id } = useParams<{ id: string }>();

    const _getAcademy = async () => {
        if (id) {
            const res = await academyService.getAcademyById(id ?? "")
            if (res.academy) {
                setAcademy(res.academy)
            }
        }
        setLoading(false)
    }


    useEffect(() => {
        _getAcademy()
    }, [])

    if (loading) {
        return <Box textAlign={'center'}><CircularProgress /></Box>
    }
    if (!loading && academy) {
        return <Container>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'baseline'}
                textAlign={'left'}
            >
                <Box>
                    <Typography variant='h2' textAlign={'start'}>
                        {academy?.name}
                    </Typography>

                    <Box display={'flex'}>
                        <Typography >{Formatters.formateLocalTZ(academy.startDate)} - {Formatters.formateLocalTZ(academy.endDate)}</Typography>
                    </Box>
                </Box>

                <Button
                    variant='contained'
                    color='success'
                    onClick={() => { }}
                >
                    Edit Academy
                </Button>
            </Box>

            <Divider />
            <StyleHelper.VerticalSpace />
            <Typography textAlign={'left'} variant='body2'>{academy.description}</Typography>

        </Container>
    }
    return <Typography >Could not find this academy</Typography>

}